import React, { Component } from 'react'
import { Button, Col, Row } from 'reactstrap'
import { inject, observer } from 'mobx-react'
import { formatNullableValue } from '../../../utils/formatar';
import { IconeInformacao } from '../../comum/components/Icones';


@inject("store")
@observer
export default class CardAnaliseCritica extends Component {

    constructor(props){
        super(props)

        this.controller = this.props.controller

        this.renderValor = this.renderValor.bind(this)
        this.renderObsIcon = this.renderObsIcon.bind(this)
        this.renderBotao = this.renderBotao.bind(this)

    }

    //Para o icone de observações tecon
    renderObsIcon = (status) => {
        if(!this.controller.naoMostrarObs.includes(status) && this.props.data.ListaAnaliseCriticaHistorico.length > 0){
            return (
                <span onClick={() => this.controller.abrirObsFluxo(this.props.data.AnaliCritId, this.props.data)}>
                    <IconeInformacao 
                        tamanho="lg" />
                </span>
                )
        }else{
            return "---"
        }
    }

    //Para os botões de edição e envio de análise
    renderBotao = (status, tipo) => {
        if(this.controller.editaveis.includes(status)){
            if(tipo === 'aprovar'){
                return (<Button onClick={() => this.controller.onClickTabela(this.props.data.AnaliCritId, "Enviar")}>Enviar</Button>)
            }else{
                return (<Button onClick={() => this.controller.onClickTabela(this.props.data.AnaliCritId, "Editar")}>Editar</Button>)
            }
        }else{
            return "---"
        }
    }

    renderValor = (col) => {
        if(col.dataField === 'ListaAnaliseCriticaHistorico'){
            return this.renderObsIcon(this.props.data.IndStatus)
        }else if(col.dataField === 'aprovar' || col.dataField === 'acao'){
            return this.renderBotao(this.props.data.IndStatus, col.dataField)
        }else{
            return (col.formatter ?
            (
                col.formatExtraData ?
                formatNullableValue(col.formatter(col.dataField.split('.').reduce((o,i)=>o[i], this.props.data), col, null, col.formatExtraData))
                :
                formatNullableValue(col.formatter(col.dataField.split('.').reduce((o,i)=>o[i], this.props.data)))
            )
            :
            formatNullableValue(col.dataField.split('.').reduce((o,i)=>o[i], this.props.data)))
        }
    }
    
    render() {
        return (
            <Col xs={12} md={6} lg={4} >
                <div className="card-booking">
                    <Row>
                        {this.props.colunas.map((col, index) => {
                            return (
                                <Col xs={6} className="px-0" key={index}>
                                    <div className="info bg-cinza">
                                        <div className="titulo">{col.text === "" ? "Observações Tecon" : col.text}</div>
                                            <div className="valor" >{
                                                this.renderValor(col)
                                            }</div>
                                    </div>
                                </Col>
                            )
                        })}
                    </Row>
                </div>
            </Col>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/analise/components/CardAnaliseCritica.js